import { useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { isValidEmailAddress } from 'utils/misc';

import { trialBuy, TrialType } from 'RestAPIs/trials';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';

import { Dialog, showSnackbar } from 'components/shared';

type IProps = {
  onHidden: () => void;
  onRequestSent: () => void;
};

export default function EmbeddedDashboardBuyDialog({
  onHidden,
  onRequestSent
}: IProps) {
  const { t } = useTranslation('common');
  const [hide, setHide] = useState(false);
  const [isSendingBuyRequest, setIsSendingBuyRequest] = useState(false);
  const [isValidEmailAddresss, setIsValidEmailAddresss] = useState(true);
  const [isRequestSent, setIsRequestSent] = useState(false);
  const emailInputRef = useRef(document.createElement('input'));

  const buyAdvanced = () => {
    if (!isValidEmailAddress(emailInputRef.current.value)) {
      setIsValidEmailAddresss(false);
      return;
    }

    setIsSendingBuyRequest(true);

    trialBuy({
      email: emailInputRef.current.value,
      type: TrialType.EMBEDDED_ANALYTICS
    }).then(
      () => {
        setIsRequestSent(true);
        setIsSendingBuyRequest(false);
        setHide(true);
        showSnackbar({
          message: t('embeddedDashboard.buy.requestSubmitted'),
          severity: 'success'
        });
      },
      () => {
        setIsSendingBuyRequest(false);
        showSnackbar({
          message: t('somethingWentWrong'),
          severity: 'error'
        });
      }
    );
  };

  return (
    <Dialog
      title={t('embeddedDashboard.buy.dialog.title')}
      onHidden={() => {
        if (isRequestSent) {
          onRequestSent();
        }
        onHidden();
      }}
      open={!hide}
    >
      <div style={{ marginBottom: 20 }}>
        <TextField
          label={t('emailAddress')}
          variant="standard"
          sx={{ width: '100%' }}
          inputRef={emailInputRef}
          disabled={isSendingBuyRequest}
          helperText={isValidEmailAddresss ? null : t('invalidEmailAddress')}
          error={!isValidEmailAddresss}
          onBlur={(e) =>
            setIsValidEmailAddresss(isValidEmailAddress(e.target.value))
          }
        />
      </div>
      <div className="d-flex h-center">
        {isSendingBuyRequest && <CircularProgress />}
        {!isSendingBuyRequest && (
          <div style={{ height: 40 }} className="d-flex v-center h-center">
            <Button onClick={buyAdvanced} color="primary" variant="contained">
              {t('send')}
            </Button>
          </div>
        )}
      </div>
    </Dialog>
  );
}
